import { roles } from '@nxsys/store/constants';
import InvoiceListing from '../../../modules/invoices/listing/InvoiceListing';
import CreateInvoice from '../../../modules/invoices/create/CreateInvoice';
import InvoiceDetail from '../../../modules/invoices/detail/InvoiceDetail';
import CreditNoteListing from '../../../modules/invoices/listing/CreditNoteListing';
import CreateCreditNote from '../../../modules/invoices/create/CreateCreditNote';
import CreditNoteDetail from '../../../modules/invoices/detail/CreditNoteDetail';

export const invoicesConfig = [
  {
    permittedRole: [roles.admin, roles.employer, roles.agency],
    path: '/invoices',
    element: <InvoiceListing />,
  },
  {
    permittedRole: [roles.admin, roles.employer],
    path: '/invoices/create-invoice',
    element: <CreateInvoice />,
  },
  {
    permittedRole: [roles.admin, roles.employer, roles.agency],
    path: '/invoices/invoice/:id',
    element: <InvoiceDetail />,
  },
  {
    permittedRole: [roles.admin, roles.employer, roles.agency],
    path: '/invoices/credit-notes',
    element: <CreditNoteListing />,
  },
  {
    permittedRole: [roles.admin, roles.employer],
    path: '/invoices/create-invoice-credit',
    element: <CreateCreditNote />,
  },
  {
    permittedRole: [roles.admin, roles.employer, roles.agency],
    path: '/invoices/credit-note/:id',
    element: <CreditNoteDetail />,
  },
];
